import { backEndMessages } from "../constants/BackEndMessages/backEndMessages";

export const translateBackendError = (backendMessage, language) => {
  if (!backendMessage) {
    return backEndMessages["DEFAULT_BAD_REQUEST"][language];
  }
  const matchedKey = Object.keys(backEndMessages).find((key) =>
    backendMessage.startsWith(key)
  );
  if (matchedKey) {
    const translatedText = backEndMessages[matchedKey][language];
    const specificData = backendMessage.substring(matchedKey.length).trim();
    return `${translatedText} ${backEndMessages.details[language]} ${specificData}`;
  }

  return backendMessage;
};
